// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2_oR2","unreadBadge":"styles_unreadBadge__1sBn-","modalContent":"styles_modalContent__3NCh3","modal":"styles_modal__byuzn"};